import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
// import ColorModeIconDropdown from '../../shared-theme/ColorModeIconDropdown';
import Sitemark from "./SitemarkIcon";
import { COLOR_MAIN } from "../utils/Colors";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LanguageSelectView } from "./LanguageSelectView";

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexShrink: 0,
  borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
  backdropFilter: "blur(24px)",
  border: "1px solid",
  borderColor: (theme.vars || theme).palette.divider,
  backgroundColor: theme.vars
    ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
    : alpha(theme.palette.background.default, 0.4),
  boxShadow: (theme.vars || theme).shadows[1],
  padding: "8px 12px",
}));

export default function AppAppBar() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const navigate = useNavigate();

  const { t } = useTranslation();

  return (
    <AppBar
      position="fixed"
      enableColorOnDark
      sx={{
        boxShadow: 0,
        bgcolor: "transparent",
        backgroundImage: "none",
        mt: "calc(var(--template-frame-height, 0px) + 28px)",
      }}
    >
      <Container maxWidth="lg">
        <StyledToolbar variant="dense" disableGutters>
          <Box
            sx={{ flexGrow: 1, display: "flex", alignItems: "center", px: 0 }}
          >
            <Sitemark />
            <Box sx={{ display: { xs: "none", md: "flex" }, pl: 1 }}>
              <Button
                variant="text"
                size="small"
                sx={{ textTransform: "none", color: COLOR_MAIN }}
                href="#features"
              >
                {t("features")}
              </Button>
              {/* <Button
                variant="text"
                color="info"
                size="small"
                sx={{ textTransform: "none", color: COLOR_MAIN }}
                href="#testimonials"
              >
                Testimonials
              </Button> */}
              <Button
                variant="text"
                color="info"
                size="small"
                sx={{ textTransform: "none", color: COLOR_MAIN }}
                href="#highlights"
              >
                {t("highlights")}
              </Button>
              <Button
                variant="text"
                color="info"
                size="small"
                sx={{ textTransform: "none", color: COLOR_MAIN }}
                href="#pricing"
              >
                {t("pricing")}
              </Button>
              <Button
                variant="text"
                color="info"
                size="small"
                sx={{ minWidth: 0, textTransform: "none", color: COLOR_MAIN }}
                href="#faq"
              >
                {t("faq")}
              </Button>
            </Box>
          </Box>
          <LanguageSelectView />
          <Box sx={{ display: { xs: "flex", md: "none" }, gap: 1 }}>
            <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="top"
              open={open}
              onClose={toggleDrawer(false)}
              PaperProps={{
                sx: {
                  top: "var(--template-frame-height, 0px)",
                },
              }}
            >
              <Box sx={{ p: 2, backgroundColor: "background.default" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <IconButton onClick={toggleDrawer(false)}>
                    <CloseRoundedIcon />
                  </IconButton>
                </Box>

                <MenuItem
                  onClick={() => {
                    navigate("#features");
                    toggleDrawer(false);
                  }}
                >
                  {t("features")}
                </MenuItem>
                {/* <MenuItem
                  onClick={() => {
                    navigate("#testimonials");
                    toggleDrawer(false);
                  }}
                >
                  Testimonials
                </MenuItem> */}
                <MenuItem
                  onClick={() => {
                    navigate("#highlights");
                    toggleDrawer(false);
                  }}
                >
                  {t("highlights")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    navigate("#pricing");
                    toggleDrawer(false);
                  }}
                >
                  {t("pricing")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    navigate("#faq");
                    toggleDrawer(false);
                  }}
                >
                  {t("faq")}
                </MenuItem>
              </Box>
            </Drawer>
          </Box>
        </StyledToolbar>
      </Container>
    </AppBar>
  );
}
